import React from 'react';
import { useHistory } from 'react-router-dom';
import RouteOverviewTreePopup from '@Pages/RetroSynthesis/RouteTree/components/RouteOverviewTreePopup';
import { ButtonWithIcon } from '@els/els-react--button';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { onRouteViewClick } from '@Pages/RetroSynthesis/ProjectRoutes/analytics';

import './RouteOverviewTreePopupContainer.scss';

export default function RouteOverviewTreePopupContainer({
  selfClose,
  treeList,
  routeName,
  projectId,
  routeId,
  isPredictedRoute,
  projectsInfo,
  routes,
}) {
  const history = useHistory();

  const navigateToRouteTreeView = () => {
    history.push(RsRoute.getProjectRouteTreeViewLink(projectId, routeId));
    const projectInfo = (projectsInfo && projectsInfo[projectId]) || {};
    onRouteViewClick(
      projectId,
      routes.filter((r) => routeId === r.id),
      projectInfo
    );
    selfClose();
  };

  return (
    <RouteOverviewTreePopup
      treeList={treeList}
      selfClose={selfClose}
      routeName={routeName}
      className="route-overview-tree-popup-container"
      footerClassName="route-overview-tree-popup-container__footer"
      footer={
        <ButtonWithIcon
          data-e2e="view-in-tree-view"
          type="primary"
          size="small"
          sprite="ChevronRight"
          linkIconSize="s"
          iconRight
          onClick={navigateToRouteTreeView}
          className="e2e-view-in-tree-view">
          View in Tree view
        </ButtonWithIcon>
      }
      isPredictedRoute={isPredictedRoute}
    />
  );
}
